export default __webpack_public_path__ + "static/imgFive-8a2261b4b5178c7f8f21a7e4eb183f33.jpg";